export default "__VITE_ASSET__kgrqADAg__"